import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  CreateAuthorityMutation as CreateAuthorityMutationType,
  CreateAuthorityMutationVariables,
} from "./__generated__/CreateAuthorityMutation";

const CreateAuthorityMutation = loader("./CreateAuthorityMutation.gql");

type CreateAuthorityMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: CreateAuthorityMutationType) => void;
}) => ReactElement;

export const CreateAuthorityMutationProvider: CreateAuthorityMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<CreateAuthorityMutationType, CreateAuthorityMutationVariables>(
    CreateAuthorityMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
